var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "warning"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2780_2265",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 45,
    height: 45
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Bounding box",
    width: 45,
    height: 45,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2780_2265)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "warning_2",
    d: "M1.875 39.375L22.5 3.75L43.125 39.375H1.875ZM8.34375 35.625H36.6563L22.5 11.25L8.34375 35.625ZM22.5 33.75C23.0312 33.75 23.4766 33.5703 23.8359 33.2109C24.1953 32.8516 24.375 32.4062 24.375 31.875C24.375 31.3438 24.1953 30.8984 23.8359 30.5391C23.4766 30.1797 23.0312 30 22.5 30C21.9688 30 21.5234 30.1797 21.1641 30.5391C20.8047 30.8984 20.625 31.3438 20.625 31.875C20.625 32.4062 20.8047 32.8516 21.1641 33.2109C21.5234 33.5703 21.9688 33.75 22.5 33.75ZM20.625 28.125H24.375V18.75H20.625V28.125Z",
    fill: "#FFFFF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.b02a21b8e862a8df36c8f80cd304d515.svg";
export { ForwardRef as ReactComponent };